<template>
  <div v-show="value === id">
    <slot />
  </div>
</template>

<script setup>
defineProps({
  id: {
    type: [String, Number],
    default: "",
  },
  value: {
    type: [String, Number],
    default: "",
  },
});
</script>
